import { Link } from "react-router-dom";
import { menuItems } from "../../../mocks/menu";

export default function MenuSection() {
  return (
    <section className="py-24 bg-[#FAF8F6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#B8956A] text-xs tracking-[0.3em] uppercase mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            Menu &amp; Price
          </p>
          <h4 id="menu" className="text-3xl text-[#3D2E2A] mb-4" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 400 }}>
            <a href="#menu">施術メニュー</a>
          </h4>
          <p className="text-[#8B7355] text-sm" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            丁寧なカウンセリングで、あなたに最適なメニューをご提案します
          </p>
        </div>

        {/* Menu Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-xl overflow-hidden border border-[#EDE7DF] hover:-translate-y-1 transition-transform duration-300 cursor-pointer"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <div className="flex items-start justify-between mb-2">
                  <h3 className="text-[#3D2E2A] text-base font-medium" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                    {item.name}
                  </h3>
                  <span className="text-[#B8956A] text-sm font-medium whitespace-nowrap ml-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    {item.price}
                  </span>
                </div>
                <p className="text-[#8B7355] text-xs leading-relaxed mb-3" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  {item.description}
                </p>
                <div className="flex items-center gap-1 text-[#A8937A] text-xs" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  <span className="w-3 h-3 flex items-center justify-center"><i className="ri-time-line text-xs" /></span>
                  <span>{item.duration}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link
            to="/booking"
            className="inline-flex items-center gap-2 bg-[#3D2E2A] text-white px-10 py-4 rounded-full text-sm tracking-widest hover:bg-[#5A4035] transition-colors cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-2-line text-sm" /></span>
            このメニューで予約する
          </Link>
        </div>
      </div>
    </section>
  );
}
